import { Link } from "react-router-dom";

interface PanelNotFoundProps {
  homePath: string;
  homeLabel: string;
}

export default function PanelNotFound({ homePath, homeLabel }: PanelNotFoundProps) {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
          Bu panel sayfası bulunamadı
        </h1>
        <p className="text-sm md:text-base text-foreground-600 mt-1">
          Aradığın sayfa bu panelde mevcut değil ya da taşınmış olabilir.
        </p>
      </div>

      <div className="rounded-lg border border-dashed border-background-300 bg-background-50 p-10 md:p-14 flex flex-col items-center justify-center text-center">
        <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
          <i className="ri-compass-3-line text-2xl" aria-hidden="true"></i>
        </span>
        <p className="mt-4 font-heading font-semibold text-base text-foreground-700">Sayfa yok</p>
        <p className="mt-1.5 text-sm text-foreground-500 max-w-md">
          Sol menüdeki bağlantılardan birini kullanarak panele devam edebilirsin.
        </p>
        <Link
          to={homePath}
          className="mt-6 whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
        >
          <i className="ri-arrow-left-line" aria-hidden="true"></i>
          {homeLabel} dön
        </Link>
      </div>
    </div>
  );
}